
import axios from '../config/axios';

export const url = '/api/cotizacion8c3iv'


export const customcrearharke_67351f269633993dfe9edac8 = ({
  
  
}) => new Promise((resolve, reject) => {
  if (true) {

    axios.post(`${url}/custom/`, {
				 },
    ).then((res) => {
      if (res.data.status === 'success') {
        resolve(res.data);
      } else {
        reject(res.data); 
      }
    }).catch((error) => {
      reject(error?.response?.data);
    });
  } else {
    reject({
      status: 'error',
      info: 'Verifique los parametros requeridos',
    });
  }
});



